import React from 'react'

import { useSendResetPasswordForm } from './useResetPasswordForm'
import { FieldMessage, Input } from 'components/Inputs'
import Button from 'components/Button'
import AlertGroup from 'components/AlertGroup'
import alertMessages from 'lib/enums/alertMessages'

const SendEmail = () => {
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    isSubmitting,
    status,
  } = useSendResetPasswordForm()

  return (
    <div>
      <h1 className='text-base text-brand-900 font-medium mb-7'>
        Forgot password?
      </h1>
      <p className='text-xs font-inter text-brand-900 font-light mb-6'>
        Enter the email address associated with your account and we will send
        you a link to reset your password.
      </p>
      <div>
        <form onSubmit={handleSubmit}>
          {status?.error ? (
            <AlertGroup alert={alertMessages[status?.error?.message]} />
          ) : null}
          <div className='space-y-4'>
            <div>
              <Input
                id='email'
                name='email'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                hasError={touched.email && errors.email}
              />
              {errors.email ? (
                <FieldMessage className='text-alert'>
                  {errors.email}
                </FieldMessage>
              ) : null}
            </div>
            <Button
              center={false}
              type='submit'
              className='w-full'
              disabled={isSubmitting}
              loading={isSubmitting}
              hasIcon>
              Send password reset email
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default SendEmail
